import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {PeriodScheduleSearchModel} from "../period-schedule-search.model";
import {PeriodScheduleEntityModel} from "../period-schedule-entity.model";

@Component({
    selector: "wbo-period-schedule-search-page",
    templateUrl: "./period-schedule-search-page.component.html",
    providers: [provideSearchModel(PeriodScheduleSearchModel), provideEntityModel(PeriodScheduleEntityModel)]
})
export class PeriodScheduleSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
